import { Text } from '@fluentui/react-components';
import React, { cloneElement, FC, ReactElement } from 'react';
import cn from 'classnames';
import './TimetablePeriodInfoRow.scss';

export interface TimetablePeriodInfoRowProps {
  icon: ReactElement<{ className?: string }>;
  label: string;
  value: JSX.Element;
}

/**
 * Displays additional information for a period in the period details popup.
 */
export const TimetablePeriodInfoRow: FC<TimetablePeriodInfoRowProps> = ({ icon, label, value }) => {
  const iconWithClass = cloneElement(icon, {
    className: cn('timeTablePeriodInfoRow__icon', icon.props.className),
  });

  return (
    <div className="timeTablePeriodInfoRow flex items-center gap-3">
      <div className="iconWrapper items-center justify-center">{iconWithClass}</div>
      <div className="flex flex-col  content">
        <Text>{label}</Text>
        <Text size={200} weight="regular" className="text-grey">
          {value}
        </Text>
      </div>
    </div>
  );
};
